// extracted by mini-css-extract-plugin
export var active = "_27-7";
export var backButton = "_27-6";
export var collapseBar = "_27-f";
export var collapseMode = "_27-h";
export var dragHandle = "_27-a";
export var dropdownIcon = "_27-d";
export var hidden = "_27-n";
export var iconContainer = "_27-k";
export var iconSwapper = "_27-m";
export var navItem = "_27-4";
export var navItemIcon = "_27-c";
export var navProfile = "_27-5";
export var notificationDot = "_27-l";
export var optionsContainer = "_27-e";
export var primaryNav = "_27-0";
export var primaryTab = "_27-i";
export var secondaryNav = "_27-1";
export var selected = "_27-j";
export var settingsNav = "_27-2";
export var settingsNavItems = "_27-3";
export var show = "_27-b";
export var sideNav = "_27-g";
export var teamItem = "_27-8";
export var userProfileItem = "_27-9";